module.exports = __webpack_public_path__ + "img/third-section.69e495b4.webp";